import { Component, Input } from '@angular/core';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() public icon: boolean;
  @Input() public fixed: boolean;
  @Input() public fullScreen: boolean;
  @Input() public background: boolean;

  constructor() {
    this.icon = false;
    this.fullScreen = false;
    this.background = false;
  }
}
